import { Injectable } from '@angular/core';
import moment, { Moment } from 'moment';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificationService {

  constructor() { }

  isCertificationMode(): boolean {
    let certification: boolean;
    const certificationStored = localStorage.getItem('certificationMode');
    if (certificationStored == null) {
      certification = environment.modeCertification;
      localStorage.setItem('certificationMode', JSON.stringify(certification));
    } else {
      certification = JSON.parse(certificationStored);
    }

    return certification;
  }

  toggleCertificationMode(): void {
    const certificationStored = localStorage.getItem('certificationMode');
    if (certificationStored != null) {
      const certification = JSON.parse(certificationStored);
      localStorage.setItem('certificationMode', JSON.stringify(!certification));
      if (certification) {
        this.unsetCertificationDateDuJour();
      }
    }
  }

  getCertificationDateDuJour(): Moment | undefined {
    const dateStored = localStorage.getItem('certificationDateDuJour');
    if (dateStored) {
      return moment(JSON.parse(dateStored));
    }
    return;
  }

  setCertificationDateDuJour(dateDuJour: Moment): void {
    localStorage.setItem('certificationDateDuJour', JSON.stringify(dateDuJour.toDate()));
  }

  unsetCertificationDateDuJour(): void {
    localStorage.removeItem('certificationDateDuJour');
  }

}
